var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconExchange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Exchange icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 204.22 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "b",
    "data-name": "path2170",
    d: "M179.26.42c-16.52,0-37.63.19-37.63.19-1.12-.09-2.57.19-5.15,3.46-1.78,2.29-16.06,24.11-28.18,42.69l33.05,53.32c14.7-22.14,59.49-90.16,60.85-92.21,1.59-2.43-.8-6.79-3.6-7.26-1.17-.14-9.41-.19-19.33-.19ZM141.3,109.67l-35.34,51.63c11.84,19,30.24,48.12,32.11,51.02,2.34,3.74,3.98,3.56,5.15,3.46,0,0,54.07.47,56.87,0s5.24-4.82,3.6-7.26c-1.36-2.06-49.38-77.94-62.4-98.86Z",
    fill: "#17477e",
    fillRule: "evenodd",
    strokeWidth: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "c",
    "data-name": "path7074",
    d: "M22.31,0c-2.25,0-4.31,0-5.99.05-7.72.09-8.61,5.94-6.41,9.41,2.34,3.7,59.92,94.79,59.92,94.79l-.05.09h68.25L77.92,9.03c-2.67-3.89-4.59-8.43-13.48-8.75,0,0-26.35-.28-42.13-.28ZM81.47,188.83c-3.56,5.2-6.88,10.06-9.78,14.23,2.9-4.17,6.23-8.99,9.78-14.23ZM67.67,208.86c-1.22,1.73-1.97,3-2.67,3.93.7-.94,1.45-2.2,2.67-3.93Z",
    fill: "#8b181b",
    fillRule: "evenodd",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    "data-name": "path5131",
    d: "M69.73,104.34c-.09.14-66.05,98.44-68.2,101.53-2.15,3.04-2.71,9.27,3,9.83,5.76.56,19.89-.09,35.76-.23,25.79-.19,21.86,1.22,27.38-6.65,19.66-27.95,70.4-104.39,70.4-104.39l-.09-.14h-68.25v.05Z",
    fill: "#c5202d",
    fillRule: "evenodd",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExchange);
export default __webpack_public_path__ + "static/media/Icon-Exchange.5458857f69588b9984cb315f88dc8d96.svg";
export { ForwardRef as ReactComponent };